import { useTranslation } from "react-i18next";
import { CacheRefreshButton } from "@/shared/components/CacheRefreshButton";
import { useRefreshCatalogCache } from "./use-refresh-catalog-cache";

export function RefreshCatalogButton() {
  const { t } = useTranslation();
  const refresh = useRefreshCatalogCache();
  return (
    <CacheRefreshButton
      mutation={refresh}
      labels={{
        idle: t("catalog.refresh.button"),
        pending: t("catalog.refresh.pending"),
        success: t("catalog.refresh.success"),
      }}
      errorKeys={{
        forbiddenKey: "catalog.errors.forbidden",
        serverPrefixKey: "catalog.errors.serverPrefix",
        genericKey: "catalog.refresh.error",
      }}
      testIdPrefix="refresh-catalog-cache"
    />
  );
}
